module.exports = __webpack_public_path__ + "img/IMG_0079_L_Black_MockedUp.056ddb31.jpg";